import { render, staticRenderFns } from "./_promotionSummary.vue?vue&type=template&id=246c21f3&scoped=true&lang=pug"
import script from "./_promotionSummary.vue?vue&type=script&lang=js"
export * from "./_promotionSummary.vue?vue&type=script&lang=js"
import style0 from "./_promotionSummary.vue?vue&type=style&index=0&id=246c21f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c21f3",
  null
  
)

export default component.exports